exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tel_img[data-v-054f451e] {\r\n  position: absolute;\r\n  right: 40px;\r\n  top: 50%;\r\n  -webkit-transform: translateY(-50%);\r\n          transform: translateY(-50%);\r\n  z-index: 9;\n}\ninput[data-v-054f451e]:disabled {\r\n  background-color: #fff !important;\n}\n.w105[data-v-054f451e]{\r\n  color:#999;\n}\r\n", ""]);

// exports
